export default __webpack_public_path__ + "static/media/close-opciones-arrow.2ebaf6c4.svg";